const resolveBackendStatus = (error) =>
  error?.response?.data?.status ||
  error?.data?.status ||
  error?.status ||
  error?.code ||
  "";

const resolveErrorText = (error) => {
  const values = [
    error?.response?.data?.detail,
    error?.response?.data?.message,
    error?.data?.detail,
    error?.data?.message,
    error?.message,
  ];

  return values
    .map((value) => {
      if (typeof value === "string") return value;
      if (typeof value?.message === "string") return value.message;
      return "";
    })
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};

export const resolveWalletAuthErrorMessage = (
  error,
  fallback = "Wallet authentication failed."
) => {
  const detail =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.data?.detail ||
    error?.data?.message ||
    error?.message;
  const message =
    typeof detail === "string"
      ? detail.trim()
      : typeof detail?.message === "string"
      ? detail.message.trim()
      : "";

  if (/^(unknown account(?: #\d+)?|user not found)$/i.test(message)) {
    return "No account exists for this wallet and role. Choose another role or contact support to register this wallet.";
  }
  return message || fallback;
};

export const isExpiredAuthSessionError = (error) => {
  if (Number(error?.response?.status) === 401) {
    return true;
  }

  if (String(resolveBackendStatus(error)).toUpperCase() === "INVALID_SESSION") {
    return true;
  }

  const detail = resolveErrorText(error);
  return (
    /\b(?:invalid|expired) (?:authentication |auth |login )?session\b/.test(
      detail
    ) ||
    /\b(?:authentication|auth|login) session (?:is |has )?expired\b/.test(
      detail
    ) ||
    /\bsession (?:is |has )?(?:invalid|expired)\b/.test(detail) ||
    /\b(?:authentication|auth) (?:is |has )?expired\b/.test(detail) ||
    /\b(?:log in|login) again\b/.test(detail)
  );
};
